module.exports = __webpack_public_path__ + "static/img/BannerLEAP.8b60bc81.jpg";